import { render } from "./Translations.vue?vue&type=template&id=018544d0&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"

import "./Translations.vue?vue&type=style&index=0&id=018544d0&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018544d0"]])

export default __exports__